import React from 'react'
import 'gatsby-remark-vscode/styles.css'
type Props = {
  children?: JSX.Element | JSX.Element[]
}

export default function DefaultSiteLayout({ children }: Props) {
  return <div className="min-h-screen pb-8 DefaultSiteLayout">{children}</div>
}
